import { render } from "./PpcBudgetAllocationWeeklyBudgetCampaignBody.vue?vue&type=template&id=3f35b9d9&scoped=true"
import script from "./PpcBudgetAllocationWeeklyBudgetCampaignBody.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationWeeklyBudgetCampaignBody.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationWeeklyBudgetCampaignBody.vue?vue&type=style&index=0&id=3f35b9d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f35b9d9"]])

export default __exports__